export default __webpack_public_path__ + "static/iphone-with-circles@2x-6b4584c1119cdcfbb4d2be515d0c20aa.png";